// src/features/audit-monitor/hooks/useAuditTitle.js
import React, { useEffect } from 'react';
import PubSub from '../../../services/PubSub';
import moment from 'moment';
import { FlexContainer, Text } from '../../../components/common'

export const useAuditTitle = () => {
    useEffect(() => {
        const leftHeader = () => (
            <FlexContainer align='center' mL={10}>
                <Text text={moment().format('LL')} style={{ fontSize: '1.25em', color: '#333333' }} />
            </FlexContainer>
        );

        PubSub.dispatch('SET_CENTER_HEADER', () => leftHeader());

        return () => {
            PubSub.dispatch('SET_CENTER_HEADER', () => '');
        };
    }, []);
};